import { Box, TabPanels, Tabs } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import {
    ContentTab,
    TabCustom,
    TabListCustom,
    TabPanelCustom
} from 'pages/Contract/styles';
import { Accesses } from './components/Accesses';
import { Onlines } from './components/Onlines';

export const ReportManagement = () => {
    const bgTransparent = {
        background: 'transparent'
    };

    return (
        <Tabs
            isLazy
            style={bgTransparent}
            as={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            height="100%"
        >
            <TabListCustom style={bgTransparent}>
                <ContentTab>
                    <TabCustom>Gestão Acessos</TabCustom>
                    <TabCustom>Usuários Conectados</TabCustom> 
                </ContentTab>
            </TabListCustom>

            <TabPanels>
                <TabPanelCustom style={bgTransparent}>
                    <Box>
                        <Accesses />
                    </Box>
                </TabPanelCustom>

                <TabPanelCustom style={bgTransparent}>
                    <Box>
                        <Onlines />
                    </Box>
                </TabPanelCustom>
            </TabPanels>
        </Tabs>
    );
};